// Lightweight device checks. Used to avoid auto-loading the heavy WebGL/3D scene
// on mobile (iOS Safari OOM → crash/reload loop) and to pick the right auth flow.
export function isIOS(): boolean {
  try {
    const ua = navigator.userAgent || '';
    // iPadOS reports as "Macintosh" but has touch points.
    return /iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && (navigator.maxTouchPoints || 0) > 1);
  } catch (_) { return false; }
}

export function isMobile(): boolean {
  try {
    const ua = navigator.userAgent || '';
    return isIOS() || /Android/i.test(ua) || window.matchMedia('(max-width: 820px)').matches;
  } catch (_) { return false; }
}

// PHONE-class device only — used for LAYOUT (not the 3D/auth safeguards, which use
// isMobile). Tablets/iPads have plenty of real estate, so they get the desktop
// layout. A phone is an iPhone/Android phone (Android tablets omit "Mobile" from
// the UA) or a genuinely small screen; an iPad's shortest side is ≥744px.
export function isPhone(): boolean {
  try {
    const ua = navigator.userAgent || '';
    if (/iPhone|iPod/.test(ua)) return true;                  // iPhone in any orientation
    if (/Android/i.test(ua) && /Mobile/i.test(ua)) return true; // Android phones ("Mobile"); tablets omit it
    // Otherwise only genuinely narrow viewports (small windows). 600px keeps iPad
    // portrait (~768px) — and every larger tablet — on the desktop layout.
    return window.matchMedia('(max-width: 600px)').matches;
  } catch (_) { return false; }
}
